import styled from 'styled-components';
import { mainColor } from '../../../lib/theme';

// Full-bleed green strip above every parent-tree page. Desktop: one row,
// title absolute-centred. Mobile (≤599px): title sits left, hamburger right —
// the inline identity / sign-out controls move into the full-screen menu.
export const HeaderBar = styled.div`
  position: relative;
  background: ${mainColor};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 24px;
  min-height: 48px;

  @media (max-width: 599px) {
    padding: 8px 12px;
    gap: 8px;
  }

  @media print {
    display: none;
  }
`;

// Absolute centring on desktop only; mobile renders the title left-aligned
// inline with the back chevron + hamburger (see ParentHeader for the layout).
export const HeaderTitle = styled.h1`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  pointer-events: none;

  @media (max-width: 599px) {
    position: static;
    transform: none;
    font-size: 18px;
    flex: 1 1 auto;
    min-width: 0;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const HeaderSide = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  @media (max-width: 599px) {
    gap: 6px;
    flex-wrap: wrap;
  }
`;

export const IdentitySubtitle = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.56);

  /* Identity moves into the mobile menu on phones; the header strip only
     carries title + hamburger there. */
  @media (max-width: 599px) {
    display: none;
  }
`;

// ----- Mobile menu (full-screen dialog) styles ---------------------------
//
// Header bar of the open menu — mirrors the green strip so the menu reads as
// an extension of the same chrome rather than a separate surface.
export const MobileMenuBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  min-height: 56px;
  background: ${mainColor};
`;

export const MobileMenuTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MobileMenuBody = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const MobileMenuIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MobileMenuIdentityLine = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
`;

// Left-justifies the icon + label inside every full-width MUI button child,
// so the menu reads as a vertical action list rather than centered chips. The
// `.MuiButton-label` override targets the inner span MUI Button renders for
// startIcon + children layout.
export const MobileMenuActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .MuiButton-root {
    justify-content: flex-start;
    padding: 12px 16px;
    text-align: left;
  }
  .MuiButton-label {
    justify-content: flex-start;
  }
`;
